import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportClientError } from "./monitoring";

export class ErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  override componentDidCatch(error: Error, info: ErrorInfo) {
    reportClientError(
      new Error(`${error.message}\n${info.componentStack ?? ""}`),
    );
    console.error("Mini App render failed", error, info.componentStack);
  }
  override render() {
    if (!this.state.failed) return this.props.children;
    const ru = localStorage.getItem("vektor-language") === "ru";
    return (
      <div className="bootstrap-state">
        <span className="brand-mark">V</span>
        <h1>{ru ? "Что-то пошло не так" : "Xatolik yuz berdi"}</h1>
        <p>
          {ru ? "Перезапустите приложение." : "Ilovani qayta ishga tushiring."}
        </p>
        <button className="primary-button" onClick={() => location.reload()}>
          {ru ? "Перезапустить" : "Qayta ishga tushirish"}
        </button>
      </div>
    );
  }
}
